import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { buildDrupalImage } from '../Image';

export const mapCallToAction = (
  input: CallToActionFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'CallToAction'> => {
  return {
    key: 'CallToAction',
    input: {
      description: input.ctaDescription || '',
      title: input.ctaTitle || '',
      Link: input.ctaLink?.url
        ? buildLink({ href: input.ctaLink.url })
        : undefined,
      linkText: input.ctaLink?.text || 'Mehr erfahren',
      imgAlignment: input.imgAlignment || 'right',
      Image: input.ctaImage
        ? buildDrupalImage(input.ctaImage, 'content')
        : undefined,
    },
  };
};
